import { Divider } from '@mui/material';
import styled from 'styled-components';

export const VerticalDivider = styled(Divider)`
  margin-left: 10px;
  margin-right: 10px;
`;
